import { filterParams, fixResponseJSON } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const papService = {
  listServices: async (params) => {
    const response = await authInstance
      .get(`${url}/paps/list?` + new URLSearchParams(filterParams(params)))
      .then(async (response) => {
        return response;
      });
    return response;
  },

  clientServices: async (clientId) => {
    const response = await authInstance
      .get(`${url}/paps/client/${clientId}`)
      .then(async (response) => {
        return response;
      });
    return response;
  },
  getPAPById: async (membershipId) => {
    const response = await authInstance
      .get(`${url}/paps/${membershipId}`)
      .then(async (response) => {
        return response;
      });
    return response;
  },
  updatePAPAffiliation: async (data, membershipId) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'PUT',
      body: JSON.stringify(data),
    };

    const response = await fetch(`${url}/paps/${membershipId}`, myInit)
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updatePAPClient: async (data, customerId) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'PUT',
      body: JSON.stringify(data),
    };

    const response = await fetch(`${url}/paps/client/${customerId}`, myInit)
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  annulPAP: async (data, papId) => {
    const response = await authInstance
      .put(`${url}/paps/${papId}/annul`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getPAPCommissions: async (params) => {
    const response = await authInstance
      .get(
        `${url}/paps/papComissions?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getPAPAffiliationCommissions: async (params) => {
    const response = await authInstance
      .get(
        `${url}/paps/affiliationComissions?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getaffiliationComissionsDetail: async (params) => {
    const response = await authInstance
      .get(
        `${url}/paps/affiliationComissionsDetail?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
};
